export const DEFAULT_BOOKMARK_COLOR = '#607D8B';
export const MAX_NESTING_DEPTH = 15;
